import { directLogin } from "../../constants/actionTypes";

const verifyDirectTenant = (data) => ({
  type: directLogin.VERIFY_DIRECT_LOGIN_TENANT,
  payload: data,
});

const directTenantVerified = (data) => ({
  type: directLogin.DIRECT_LOGIN_TENANT_VERIFIED,
  payload: data,
});

const directTenantVerifyFailed = (data) => ({
  type: directLogin.DIRECT_LOGIN_TENANT_FAIL,
  payload: data,
});

const getDirectLoginAADToken = (data) => ({
  type: directLogin.GET_DIRECT_LOGIN_AAD_TOKEN,
  payload: data,
});

const directLoginForAutoOnBoardingFalse = (data) => ({
  type: directLogin.DIRECT_LOGIN_AUTO_ON_BOARD_FALSE_AAD,
  payload: data,
});

//login call for IDP user with auto onBoarding false
const directLoginForAutoOnBoardingFalseIDP = (data) => ({
  type: directLogin.DIRECT_LOGIN_AUTO_ON_BOARD_FALSE_IDP,
  payload: data,
});

//fetch token call for IDP user with auto onBoarding false
const getDirectLoginTokenForIDP = (data) => ({
  type: directLogin.GET_DIRECT_LOGIN_TOKEN_AUTO_ON_BOARD_IDP,
  payload: data,
});

// action for demand login for local user with auto on-board = true
const demandLoginLocalUser = (data) => ({
  type: directLogin.DIRECT_LOGIN_FOR_LOCAL_USER,
  payload: data,
});

// verify local user for demand login
const verifyLocalUserForDemandLogin = (data) => ({
  type: directLogin.VERIFY_DIRECT_LOGIN_LOCAL_USER,
  payload: data,
});

export {
  verifyDirectTenant,
  directTenantVerified,
  directTenantVerifyFailed,
  getDirectLoginAADToken,
  directLoginForAutoOnBoardingFalse,
  directLoginForAutoOnBoardingFalseIDP,
  getDirectLoginTokenForIDP,
  demandLoginLocalUser,
  verifyLocalUserForDemandLogin,
};
